import { BaseUnitOfWorkRequest } from "../../utilities/unit-of-work-observer";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";

export interface GetAllPermissionsRequest {
    permissionEntity: number;
    id: number;
    branchIds?: number[];
    departmentIds?: number[];
    roleIds?: number[];
    employeeIds?: number[];
}

export interface GetAllPermissionsResponse {
    permissions: PermissionModel[];
    currentPermissions: ObjectPermissionModel[];
    branchPermissions: ObjectPermissionModel[];
    departmentPermissions: ObjectPermissionModel[];
    rolePermissions: ObjectPermissionModel[];
    employeePermissions: ObjectPermissionModel[];
}

export interface UpdatePermissionsRequest extends BaseUnitOfWorkRequest {
    permissionEntity: number;
}

export interface UpdatePermissionsResponse {
}

export interface PermissionCategoryModel {
    dbId: number;
    name: string;
    description: string;
    isHidden: boolean;
    permissionTypeId: number;
    permissionType: PermissionTypeModel;
    sequence: number;
}


export interface PermissionTypeModel {
    dbId: number;
    name: string;
    description: string;
    isHidden: boolean;
    sequence: number;
}

export interface ObjectPermissionModel {
    dbId: number;
    permissionId: number;

}
export interface PermissionModel {
    dbId: number;
    permissionCategoryId?: number;
    perentId?: number;
    name: string;
    description: string;
    isHidden: boolean;
    isChecked: boolean;
    isDisabled: boolean;
    parent: PermissionModel;
    permissionCategory: PermissionCategoryModel;
}

export enum PermissionEntity {
    Branch = 1,
    Department = 2,
    Role = 3,
    User = 4
}

export interface RolePermissionAuditParameterModel {
    id: number;
    entityType: EntityTypes;
}